/**
 * Fetch like response
 * @private
 */
class Response {
    constructor(response) {
        this.response = response;
    }

    /**
     * @returns {Promise}
     */
    json() {
        return new Promise((resolve, reject) => {
            try {
                resolve(JSON.parse(this.response));
            } catch (e) {
                reject(e);
            }
        });
    }
}

/**
 * @param obj
 * @param resolve
 * @param reject
 * @returns {XMLHttpRequest}
 * @private
 */
const makeRequest = (obj, resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(obj.method || "GET", obj.url);
    if (obj.headers) {
        Object.keys(obj.headers).forEach((key) => {
            xhr.setRequestHeader(key, obj.headers[key]);
        });
    }
    xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
            resolve(new Response(xhr.response));
        } else {
            reject(xhr.statusText);
        }
    };
    xhr.onerror = () => reject(xhr.statusText);
    xhr.send(obj.body);

    return xhr;
};

/**
 * @param obj
 * @returns {Promise<any>}
 * @private
 */
const request = (obj) => {
    return new Promise((resolve, reject) => {
        makeRequest(obj, resolve, reject);
    });
};

/**
 * @typedef {Object} JSONPOptions
 * @property {String} prefix callback prefix (defaults to `__jp`)
 * @property {String} qs parameter (defaults to `callback`)
 * @property {Number} timeout how long after the request until a timeout error
 * is emitted (defaults to `15000`)
 */

/**
 * Builds a query string from dictionary.
 * @param {Object} params
 * @returns {string}
 * @memberOf woosmap.network
 */
function buildQueryString(params) {
    const queryStringParts = [];

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const value = params[key];

            queryStringParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    }

    return queryStringParts.join("&");
}

/**
 * Fetches the url content.
 * @param {String} url
 * @return {Promise}
 * @memberOf woosmap.network
 */
function fetch(url) {
    return request({ url: url });
}

/**
 * Posts JSON data to url
 * @param {String} url
 * @param {Object} data
 * @return {Promise}
 * @memberOf woosmap.network
 */
function post(url, data) {
    return request({ method: "POST", url: url, body: JSON.stringify(data) });
}

module.exports = {
    fetch,
    post,
    buildQueryString,
};
